module.exports = __webpack_public_path__ + "static/media/Sreemongol.8f49c158.png";